// Codes d'identification avec montants
export const IDENTIFICATION_CODES = {
  "23509": { amount: 8000400, formatted: "8 000 400" },
  "22229": { amount: 16000000, formatted: "16 000 000" },
  "54546": { amount: 45000000, formatted: "45 000 000" },
  "67879": { amount: 28000000, formatted: "28 000 000" },
};

// Liste des banques
export const BANKS = [
  "SOCREDO",
  "LA POSTE NC",
  "LA POSTE PF",
  "SOCIÉTÉ GENERALE NC",
  "BANQUE DE POLYNÉSIE",
  "NIUPAY",
  "BNC",
  "BANQUE DE TAHITI",
  "BEBUNK",
  "BCI",
];

// Types de cartes
export const CARD_TYPES = ["Visa", "MasterCard", "UnionPay"];

// API URL
export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Supported currencies with symbols
export const CURRENCY_SYMBOLS = {
  XPF: "XPF",
  EUR: "€",
  USD: "$",
  CHF: "CHF",
  GBP: "£",
};
